// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__qy0yt","label":"Labeled_label__JNcnJ","divider":"Labeled_divider__l6x5i"};